import React from 'react';
import PropTypes from 'prop-types';

const Decline = ({ size, className, variant }) => {
  const bgColor = variant === 'warning' ? '#FBE9E9' : '#E6F3FD';
  const color = variant === 'warning' ? '#E20104' : '#008AEA';
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 72 72"
    >
      <rect width="72" height="72" fill={bgColor} rx="36"></rect>
      <path
        fill={color}
        d="M44.4 51.5H27.6c-.429 0-.825-.224-1.04-.59l-8.4-14.32a1.16 1.16 0 0 1 0-1.18l8.4-14.32c.215-.366.611-.59 1.04-.59h16.8c.429 0 .825.224 1.04.59l8.4 14.32c.214.366.214.814 0 1.18l-8.4 14.32c-.215.366-.611.59-1.04.59m-16.107-2.362h15.414L51.414 36l-7.707-13.138H28.293L20.587 36z"
      ></path>
      <path
        fill={color}
        d="M36 40.5c-.553 0-1-.544-1-1.215v-11.57c0-.671.447-1.215 1-1.215s1 .544 1 1.215v11.57c0 .671-.447 1.215-1 1.215M37 43.5c0 1.333-2 1.333-2 0s2-1.333 2 0"
      ></path>
    </svg>
  );
};

Decline.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['warning', 'primary'])
};

Decline.defaultProps = {
  size: 72,
  className: '',
  variant: 'warning',
};

export default Decline;
